import { createSlice } from "@reduxjs/toolkit"; 

  export type paymentValidationNames= "customerId" | "customerName" | "email" | "phone" | "inputAmount" | "paymentDesc" | "cardHolderName" |
  "cardNumber" |"expireDate" | "cvc" | "selectedInstallment" | "installmentLimit" | "highLimit";
export type PaymentValidationType = {
  name: paymentValidationNames
}

export type PaymentPageSliceProps = {
  validationErrors: Array<PaymentValidationType>
}

export const paymentPageSlice = createSlice({
  name: "paymentPage",
  initialState: {
    validationErrors: [] 
  },
  reducers: {
    updatePaymentValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
      return state;
    },
  },

});
export const { updatePaymentValidationErrors } = paymentPageSlice.actions;

export const paymentPageSelector = (state: any) => state.paymentPage;

export const paymentPageReducer = paymentPageSlice.reducer;

 